import type { AppMeta } from '@clientline/contracts';
import type { AdminPageAccessRule } from '../../registry.ts';

/**
 * Хто бачить сторінку `mail` (ADM-906 «Пошта», ML-W5): модуль `mail` увімкнено і в людини є
 * `mail.manage`. У перший екран їде лише це (опис і код — у `page.ts`).
 */
export default {
  group: 'integrations',
  permission: (meta: AppMeta) =>
    meta.modules.includes('mail') && meta.permissions.includes('mail.manage'),
} satisfies AdminPageAccessRule;
